import {
    createRewardItem,
    deleteRewardItem,
    getRewardItem,
    getRewardItemList,
    updateRewardItem,
} from '../../services/api/rewardApi';
import {
    CLOSE_REWARD_EDITOR,
    CREATE_REWARD_ITEM,
    DELETE_REWARD_ITEM,
    GET_REWARD_ITEM,
    GET_REWARD_ITEMS,
    OPEN_REWARD_EDITOR,
    UPDATE_EDITOR_FIELD,
    UPDATE_REWARD_ITEM,
} from './actionTypes';
import { hideLoading, showLoading } from './loadingActions';
import { notifyError, notifySuccess } from './notificationActions';

export const createRewardAction = (rewardItem) => {
    return {
        type: CREATE_REWARD_ITEM,
        rewardItem,
    };
};
export const getRewardAction = (rewardItem) => {
    return {
        type: GET_REWARD_ITEM,
        rewardItem,
    };
};
export const getRewardItemsAction = (rewardItems) => {
    return {
        type: GET_REWARD_ITEMS,
        rewardItems,
    };
};
export const updateRewardItemAction = (rewardItem) => {
    return {
        type: UPDATE_REWARD_ITEM,
        rewardItem,
    };
};
export const deleteRewardItemAction = (id) => {
    return {
        type: DELETE_REWARD_ITEM,
        id,
    };
};

export const openRewardEditor = (id) => {
    return {
        type: OPEN_REWARD_EDITOR,
        id,
    };
};
export const closeRewardEditor = () => {
    return {
        type: CLOSE_REWARD_EDITOR,
    };
};
export const updateEditorField = (field, value) => {
    return {
        type: UPDATE_EDITOR_FIELD,
        field,
        value,
    };
};

export function createReward(reward) {
    return function (dispatch, getState) {
        const { auth } = getState();
        const { market, category, brand } = auth?.user;

        return Promise.resolve()
            .then(() => dispatch(showLoading()))
            .then(() => createRewardItem(market, category, brand, reward))
            .then((result) => dispatch(createRewardAction(result.data)))
            .then(() => dispatch(closeRewardEditor()))
            .then(() => dispatch(notifySuccess('Success', 'Reward created successfully')))
            .catch((error) => dispatch(notifyError('Error', 'Unable to create the reward')))
            .finally(() => dispatch(hideLoading()));
    };
}

export function getRewardList() {
    return function (dispatch, getState) {
        const { auth } = getState();
        const { market, category, brand } = auth?.user;

        return Promise.resolve()
            .then(() => dispatch(showLoading()))
            .then(() => getRewardItemList(market, category, brand))
            .then((result) => dispatch(getRewardItemsAction(result.data)))
            .catch((err) => dispatch(notifyError('Error', 'Unable to retrive the reward list')))
            .finally(() => dispatch(hideLoading()));
    };
}

export function getReward(rewardId) {
    return function (dispatch, getState) {
        const { auth } = getState();
        const { market, category, brand } = auth?.user;

        return Promise.resolve()
            .then(() => dispatch(showLoading()))
            .then(() => getRewardItem(market, category, brand, rewardId))
            .then((result) => dispatch(getRewardAction(result.data)))
            .catch((error) => dispatch(notifyError('Error', 'Unable to retrive the reward')))
            .finally(() => dispatch(hideLoading()));
    };
}

export function renderRewardEditor(rewardId) {
    return function (dispatch, getState) {
        return Promise.resolve()
            .then(() => dispatch(getReward(rewardId)))
            .then(() => dispatch(openRewardEditor(rewardId)))
            .catch((err) => dispatch(notifyError('Error', 'Unable to open the reward')));
    };
}

export function updateReward(id, body) {
    return function (dispatch, getState) {
        const { auth } = getState();
        const { market, category, brand } = auth?.user;

        return Promise.resolve()
            .then(() => dispatch(showLoading()))
            .then(() => updateRewardItem(market, category, brand, id, body))
            .then((result) => updateRewardItemAction(result.data))
            .then(() => dispatch(closeRewardEditor()))
            .then(() => dispatch(notifySuccess('Success', 'Reward updated successfully')))
            .catch((error) => dispatch(notifyError('Error', 'Unable to update the reward')))
            .finally(() => dispatch(hideLoading()));
    };
}

export function deleteReward(id) {
    return function (dispatch, getState) {
        const { auth } = getState();
        const { market, category, brand } = auth?.user;

        return Promise.resolve()
            .then(() => dispatch(showLoading()))
            .then(() => deleteRewardItem(market, category, brand, id))
            .then(() => dispatch(deleteRewardItemAction(id)))
            .then(() => dispatch(closeRewardEditor()))
            .then(() => dispatch(notifySuccess('Success', 'Reward deleted successfully')))
            .catch((err) => dispatch(notifyError('Error', 'Unable to delete the reward')))
            .finally(() => dispatch(hideLoading()));
    };
}
